import axiosPrivate from './axiosPrivate';

const catalogo = () => {
  return axiosPrivate.get('ceso/catalogo').then((r) => r.data);
};

const usuariosOpciones = () => {
  return axiosPrivate.get('ceso/usuarios-opciones').then((r) => r.data);
};

const listar = (params = {}) => {
  return axiosPrivate.get('ceso', { params }).then((r) => r.data);
};

const crear = (payload) => {
  return axiosPrivate.post('ceso', payload).then((r) => r.data);
};

const actualizar = (payload) => {
  return axiosPrivate.put('ceso', payload).then((r) => r.data);
};

const subirArchivo = (id_cese, campo, archivo, usuario_id) => {
  const fd = new FormData();
  fd.append('id_cese', id_cese);
  fd.append('campo', campo);
  fd.append('archivo_ceso', archivo);
  fd.append('usuario_id', usuario_id);
  return axiosPrivate.post('guardarDocumentoCeso', fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }).then((r) => r.data);
};

export default {
  catalogo,
  usuariosOpciones,
  listar,
  crear,
  actualizar,
  subirArchivo,
};
